import { render, staticRenderFns } from "./ContentCollectionComponent.vue?vue&type=template&id=70067229&scoped=true"
import script from "./ContentCollectionComponent.vue?vue&type=script&lang=js"
export * from "./ContentCollectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentCollectionComponent.vue?vue&type=style&index=0&id=70067229&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70067229",
  null
  
)

export default component.exports